import { useSelector } from 'react-redux';
import classNames from 'classnames';
import omit from 'hs-lodash/omit';
import pick from 'hs-lodash/pick';
import { STACK } from 'EmailEditorUI/constants/SectionLayoutConstants';
// @ts-expect-error no declarations found for module
import { getIsSectionBoxedHelper } from 'EmailEditorUI/redux/selectors/sectionSelectors';
// @ts-expect-error no declarations found for module
import { getLayoutSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import useSectionBreakpointStyles from 'EmailEditorUI/hooks/styleSettings/useSectionBreakpointStyles';
import HiddenElementIndicator from 'LayoutBuilderUI/components/overlays/HiddenElementIndicator';
import useSectionBackgroundCss from 'LayoutBuilderUI/hooks/css/useSectionBackgroundCss';
import useSectionSpacingCss from 'LayoutBuilderUI/hooks/css/useSectionSpacingCss';
import { useElementVisibilityContext } from 'LayoutBuilderUI/context/ElementVisibilityContext';
import { useSectionBoundariesContext } from 'LayoutBuilderUI/context/SectionBoundariesContext';
import HiddenElementOverlay from '../overlays/HiddenElementOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HSE_SECTION_STYLES = ['opacity'];
const BG_STYLES = ['backgroundImage', 'backgroundRepeat', 'backgroundSize', 'backgroundPosition', 'backgroundColor'];
const getHSESectionStyles = (backgroundType, styles) => {
  const styleKeys = backgroundType === 'FULL' ? HSE_SECTION_STYLES.concat(BG_STYLES) : HSE_SECTION_STYLES;
  return pick(styles, styleKeys);
};
const getHSEColumnContainerStyles = (backgroundType, styles) => {
  const blocklistedStyleKeys = backgroundType === 'CONTENT' ? HSE_SECTION_STYLES : HSE_SECTION_STYLES.concat(BG_STYLES);
  return omit(styles, blocklistedStyleKeys);
};
const useEffectiveBackgroundType = ({
  section,
  index,
  isSingleColumnFullWidth
}, layoutSettings) => {
  const {
    backgroundType
  } = useSectionBreakpointStyles(section);
  const insideBox = getIsSectionBoxedHelper(layoutSettings, index);
  if (isSingleColumnFullWidth) {
    return 'FULL';
  } else if (insideBox) {
    return 'CONTENT';
  }
  return backgroundType || 'CONTENT';
};
function RowDOM(props) {
  const {
    canResize,
    children,
    index,
    isSingleColumnFullWidth,
    numSections,
    section,
    selectable
  } = props;
  const {
    isHidden
  } = useElementVisibilityContext();
  const layoutSettings = useSelector(getLayoutSettings);
  const effectiveBackgroundType = useEffectiveBackgroundType(props, layoutSettings);
  const id = (section === null || section === void 0 ? void 0 : section.get('id')) || 'no-section';
  const numColumns = (section === null || section === void 0 ? void 0 : section.get('columns').size) || 1;
  const stack = section === null || section === void 0 ? void 0 : section.getIn(['style', 'stack']);
  const contentAreaStyles = useSectionBackgroundCss(props);
  const spacingStyles = useSectionSpacingCss(section, selectable);
  const sectionStyles = getHSESectionStyles(effectiveBackgroundType, contentAreaStyles);
  const columnContainerStyles = Object.assign({}, getHSEColumnContainerStyles(effectiveBackgroundType, contentAreaStyles), spacingStyles, {
    minHeight: isHidden ? '100px' : undefined
  });
  const isContentWidth = effectiveBackgroundType === 'CONTENT';
  const {
    borderBottom,
    borderTop,
    isBoxed
  } = useSectionBoundariesContext();
  const columnContainerClasses = classNames('hse-column-container', isBoxed && 'hse-border', borderTop && 'hse-border-top', borderBottom && 'hse-border-bottom', stack === STACK.NONE && 'hse-no-stack-row');
  const classes = classNames('hse-section', isSingleColumnFullWidth ? 'hse-section-full-width' : !canResize && `hse-section-${numColumns}-col`, isContentWidth && [index === 0 && 'hse-section-first', index === numSections - 1 && 'hse-section-last'], stack === STACK.NONE && 'section-stack-none', stack === STACK.RIGHT_TO_LEFT && 'section-stack-rtl');
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs("div", {
      id: id,
      className: classes,
      style: sectionStyles,
      children: [/*#__PURE__*/_jsxs("div", {
        className: columnContainerClasses,
        style: columnContainerStyles,
        children: [children, isHidden && effectiveBackgroundType === 'CONTENT' && /*#__PURE__*/_jsx(HiddenElementOverlay, {})]
      }), isHidden && effectiveBackgroundType === 'FULL' && /*#__PURE__*/_jsx(HiddenElementOverlay, {}), isHidden && /*#__PURE__*/_jsx(HiddenElementIndicator, {})]
    })
  );
}
export default RowDOM;